module.exports = __webpack_public_path__ + "img/calendar-primary.3bf304fa.svg";